import React from "react";
import { useSystemPopStore } from "../../store/useSystemPopStore";
import { ReactComponent as CloseIcon } from "../../assets/icons/closeGrayIcon.svg";

const SystemPop: React.FC = () => {
    const { isVisible, title, content, rightButton, onRightClick, hidePop, type } = useSystemPopStore();

    if (!isVisible) return null;

    const handleConfirm = () => {
        if (onRightClick) onRightClick();
        hidePop();
    };

    const handleCancel = () => {
        hidePop();
    };

    return (
        <div className="fixed inset-0 rounded-xl bg-gray-800 bg-opacity-50 flex items-center justify-center z-[200]">
            <div className="bg-white rounded-lg w-[320px] overflow-hidden">
                <div className="flex justify-end p-2">
                    <CloseIcon onClick={hidePop} className="cursor-pointer" />
                </div>
                <div className="flex flex-col gap-2 px-4 pb-5 text-center">
                    {title && <p className="text-xl font-bold" dangerouslySetInnerHTML={{ __html: title }} />}
                    {content && <p className="text-lg text-gray2" dangerouslySetInnerHTML={{ __html: content }} />}
                </div>

                <div className="flex text-lg font-bold">
                    <button
                        className={`${rightButton ? "bg-gray5" : type === "negative" ? "bg-error text-white" : "bg-blue text-white"} w-full py-3`}
                        onClick={handleCancel}
                    >
                        {rightButton ? "취소" : "확인"}
                    </button>
                    {rightButton && (
                        <button
                            className={`text-white w-full py-3 ${type === "negative" ? "bg-error" : "bg-blue"}`}
                            onClick={handleConfirm}
                        >
                            {rightButton}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SystemPop;
